import './corkysgamingbistro/style';
import FormStructure from './corkysgamingbistro/form_structure';
export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/web_inquiry/inquiry-renderer/client_forms/includes.js